export const backgroundColourVariants = {
    white: 'bg-white',
    'grey-light': 'bg-grey-100',
    'blue-light': 'bg-blue-light',
    'blue-extra-light': 'bg-blue-extra-light',
    'purple-light': 'bg-purple-light',
    'purple-extra-light': 'bg-purple-extra-light',
    'tan-light': 'bg-tan-light',
    blue: 'bg-blue',
};
